<template>
  <div class="text-center p-8">
    <h5
    class="text-xl mb-4">
    You don't have access to this page.
  </h5>
    <h5
    class="text-lg mb-4">
    If you think this is an error, kindly reach out to Housing department:
  </h5>
    <a
      href="mailto:housing@digipen.edu"
      class="text-blue-600 hover:text-blue-800"
    >
      housing@digipen.edu
    </a>
  </div>
</template>
